import ActionableInsights from './ActionableInsights'

export default ActionableInsights
